<template>
  <div class="home">
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBar />
        </b-col>
        <b-col cols="12">
          <b-container class="px-0 px-sm-3">
            <b-row>
              <b-col cols="12" class="px-2 px-sm-3">
                <TopLogin />
              </b-col>
              <b-col cols="12" class="px-2 px-sm-3">
                <TopInfo />
              </b-col>
              <b-col cols="12" class="px-2 px-sm-3">
                <LottoDashboard />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <FooterIndex class="mt-2" />
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import TopBar from "@/components/TopBar.vue";
import TopLogin from "@/components/TopLogin.vue";
import TopInfo from "@/components/TopInfo.vue";
import LottoDashboard from "@/components/LottoDashboard.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    TopBar,
    TopLogin,
    TopInfo,
    LottoDashboard,
    FooterIndex,
  },
  mounted() {
    if (
        this.getAccessToken !== null &&
        this.getAccessToken !== undefined
    ) {
      this.$router.push({ name: "Member" });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken"
    })
  }
}
</script>

<style lang="scss" scoped>
.footer-index {
  background: #151515;
  border-top: #222 1px solid;
  color: lightgray;
  padding: 10px 5px 25px 5px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;

  a {
    color: goldenrod;
  }
}
</style>